import { render } from "./ModalClientAsociates.vue?vue&type=template&id=2a6e73c6&scoped=true"
import script from "./ModalClientAsociates.vue?vue&type=script&lang=js"
export * from "./ModalClientAsociates.vue?vue&type=script&lang=js"

import "./ModalClientAsociates.vue?vue&type=style&index=0&id=2a6e73c6&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6e73c6"]])

export default __exports__